import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, TrendingUp, Shield, Zap } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function ProofPoints() {
  const { lang } = useLang();

  const points = lang === 'ru' ? [
    {
      icon: CheckCircle2,
      title: 'Модель уже работает',
      desc: 'Проверенная экономика бизнеса',
    },
    {
      icon: Shield,
      title: 'Стандартизированные процессы',
      desc: 'Готовые регламенты и система',
    },
    {
      icon: TrendingUp,
      title: 'Растущий рынок',
      desc: 'Стабильный спрос круглый год',
    },
    {
      icon: Zap,
      title: '5 источников дохода',
      desc: 'Не просто игровая — полноценный бизнес',
    },
  ] : [
    {
      icon: CheckCircle2,
      title: 'El modelo ya funciona',
      desc: 'Economía de negocio comprobada',
    },
    {
      icon: Shield,
      title: 'Procesos estandarizados',
      desc: 'Reglamentos y sistema listos',
    },
    {
      icon: TrendingUp,
      title: 'Mercado en crecimiento',
      desc: 'Demanda estable todo el año',
    },
    {
      icon: Zap,
      title: '5 fuentes de ingresos',
      desc: 'No solo juegos — negocio completo',
    },
  ];

  return (
    <section className="relative py-16 md:py-20 px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {points.map((point, i) => {
            const Icon = point.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="text-center"
              >
                <div
                  className="w-16 h-16 mx-auto mb-4 rounded-2xl flex items-center justify-center"
                  style={{
                    background: 'linear-gradient(135deg, rgba(212,175,55,0.15) 0%, rgba(212,175,55,0.05) 100%)',
                    border: '1px solid rgba(212,175,55,0.3)',
                  }}
                >
                  <Icon size={28} className="text-[#D4AF37]" />
                </div>
                <h3 className="text-white font-bold text-base md:text-lg mb-2">
                  {point.title}
                </h3>
                <p className="text-[#9CA3AF] text-sm">
                  {point.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
